import { Component } from '@angular/core';
import { BaseEdit } from '../base-edit';

@Component({
    selector: 'ldw-check-edit',
    templateUrl: './check-edit.component.html',
    styleUrls: ['./check-edit.component.css'],
    standalone: false
})
export class CheckEditComponent extends BaseEdit {}
